
























































import { Popup, Button } from '@hb/coffee';
import {
  defineComponent, onBeforeUnmount, computed,
  PropType,
} from '@vue/composition-api';
import { RightPackageSourceEnum, RightPackageTypeEnum, RightSummaryType } from '@/api/rights/types';
import { ForceReadService } from '@/widgets/right-contract';

export default defineComponent({
  name: 'AutarkyRetainRightsPopup',
  components: {
    Popup,
    Button,
  },
  props: {
    rightParams: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    /** 协议预览,注入方法，兼容js调用的场景 */
    contractPreview: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
    /** 跳转详情 */
    goDetail: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
  },
  emits: ['goDetail', 'update:modelValue', 'choose', 'previewContract'],
  setup(props: any, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
    /** 是否展示popup */
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    /** 协议预览注册 */
    const {
      handleForceRead, destroyInstance,
    } = ForceReadService({
      packageType: RightPackageTypeEnum.CHANNEL_B,
      forceReadFromScene: RightPackageSourceEnum.LOAN_APPLY,
    });

    /** 点击详情 */
    const handleGoDetail = () => {
      if (props.goDetail) {
        props.goDetail();
      }
      emit('goDetail');
    };

    /** 协议预览 */
    const previewContract = async () => {
      await handleForceRead({
        contractScene: props.rightParams.contractInfo?.scene || '',
        preview: true,
      });
      if (props.contractPreview) {
        props.contractPreview();
      }
      emit('previewContract');
    };

    /** 点击确定 */
    const handleConfirm = () => {
      emit('choose', true, '同意协议并提交');
    };

    /** 点击放弃 */
    const handleReject = () => {
      emit('choose', false, '放弃优先审核');
    };

    /** 卸载 */
    onBeforeUnmount(() => {
      destroyInstance();
    });

    return {
      showPopup,
      handleGoDetail,
      previewContract,
      handleConfirm,
      handleReject,
    };
  },
});
